import React from "react"
import CookieConsent from "react-cookie-consent"

const CookieBanner = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Decline"
      enableDeclineButton
      cookieName="studio-ashby-cookie-consent"
      style={{
        background: "#633B2F", // color--primary
        fontSize: "12px",
        fontFamily: "'Matter', sans-serif",
        padding: "10px 30px",
        zIndex: 9999,
      }}
      buttonStyle={{
        background: "#F9F3F0", // color--secondary
        color: "#633B2F", // color--primary
        fontSize: "14px",
        borderRadius: "4px",
        border: "none",
        padding: "12px 24px",
        cursor: "pointer",
        fontFamily: "'Matter', sans-serif",
        fontWeight: "500",
        marginLeft: "10px",
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "#F9F3F0", // color--secondary
        fontSize: "14px",
        border: "1px solid #F9F3F0",
        borderRadius: "4px",
        padding: "12px 24px",
        cursor: "pointer",
        fontFamily: "'Matter', sans-serif",
        fontWeight: "500",
        marginLeft: "10px",
      }}
      expires={365}
      onAccept={(acceptedByScrolling) => {
        // Enable analytics, tracking, etc.
        console.log("Cookies accepted", { acceptedByScrolling })
        
        // Example: Enable Google Analytics
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
          window.gtag('consent', 'update', {
            'analytics_storage': 'granted',
            'ad_storage': 'granted'
          })
        }
        
        // Enable other tracking scripts
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push({
            event: 'cookie_consent_granted'
          })
        }
      }}
      onDecline={() => {
        // Disable non-essential cookies
        console.log("Cookies declined")
        
        // Example: Disable Google Analytics
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
          window.gtag('consent', 'update', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied'
          })
        }
        
        // Disable other tracking scripts
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push({
            event: 'cookie_consent_denied'
          })
        }
      }}
      containerClasses="cookie-banner"
      contentClasses="cookie-banner__content"
      buttonClasses="cookie-banner__accept"
      declineButtonClasses="cookie-banner__decline"
    >
      <span style={{ color: "#F9F3F0", lineHeight: "1.4" }}>
        We use cookies to enhance your browsing experience and analyse site usage.
        By clicking "Accept All", you consent to our use of cookies. You can learn more in our{" "}
        <a 
          href="/privacy-policy" 
          style={{ 
            color: "#F9F3F0", 
            textDecoration: "underline",
            fontWeight: "500"
          }}
        >
          Privacy Policy
        </a>
        .
      </span>
    </CookieConsent>
  )
}

export default CookieBanner
